// extracted by mini-css-extract-plugin
module.exports = {"container":"not_found_result_container__UUKYv","title":"not_found_result_title__10tNW","subTitle":"not_found_result_subTitle__2Lfvl"};